// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1Wnnd","detailsBorder":"styles_detailsBorder__1tRxp"};